import { storeWithExpiry } from "../../lib/localStorage";
import actions from "./editListing.actions";

export const initialState = {
  editListingData: {},
  categoryFields: {},
  updatedListingData: {},
};

const expiryPeriod = 86400 * 1000 * 7;

export default function EditListingReducer(state, action) {
  switch (action.type) {
    case actions.SET_EDIT_LISTING_DATA:
      storeWithExpiry(
        "editListingData",
        {
          ...state.editListingData,
          ...action.payload,
        },
        expiryPeriod
      );
      return {
        ...state,
        editListingData: { ...state.editListingData, ...action.payload },
      };
    case actions.SET_UPDATED_LISTING_DATA:
      storeWithExpiry(
        "updatedListingData",
        {
          ...state.updatedListingData,
          ...action.payload,
        },
        expiryPeriod
      );
      return {
        ...state,
        updatedListingData: { ...state.updatedListingData, ...action.payload },
      };
    case actions.SET_CATEGORY_FIELDS:
      storeWithExpiry(
        "editingListingCategoryFieldsConfig",
        action.payload,
        expiryPeriod
      );
      return {
        ...state,
        categoryFields: action.payload,
      };
    case actions.RESET_LISTING_DATA:
      storeWithExpiry("editListingData", action.payload, expiryPeriod);
      return {
        ...state,
        editListingData: action.payload,
      };
    case actions.CLEAR_EDIT_LISTING_DATA:
      storeWithExpiry("editListingData", {}, expiryPeriod);
      storeWithExpiry("editingListingCategoryFieldsConfig", {}, expiryPeriod);
      return {
        ...state,
        editListingData: {},
        categoryFields: {},
      };
    default:
      throw new Error("Unsupported action type at fav listings reducer");
  }
}
